import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import { AppState } from '../reducers'
import ScannerPopup from '../components/ScannerPopup'
import * as actions from '../actions'

const mapStateToProps = (state: AppState) => ({
})

const mapDispatchToProps = {
	stopScanning: actions.stopScanning,
	searchBarcode: actions.searchBarcode as any,
	push,
}

const ConnectedScannerPopup = connect(null, mapDispatchToProps)(ScannerPopup)

export type ScannerPopupProps = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps

export default ConnectedScannerPopup
